import React from 'react'
import dayjs from 'dayjs';
import { useAuth } from "../context/auth";
import '../main.css'
import MenuBar from '../clients/commons/Menu'
import PrimaryFoot from '../clients/commons/PrimaryFooter'
import ProfilePage from '../clients/ProfilePage'
import CurrentProfile from '../clients/currentProfile'
import Headers from '../clients/headers'

function Admin(props) {
  const { setAuthTokens } = useAuth();
  
  function logOut() {
    setAuthTokens();
  }
        
  return ( 
    <div className="generic">
		<div className="logins" align="center">	 			
			<Headers />
			<MenuBar /><br/><br/>
			<h1>Settings (<small>{dayjs().format("YYYY-MM-DD")}</small>)</h1><br/><br/>
			<CurrentProfile/>
			<br/><br/><PrimaryFoot />
		</div>
	</div>
  );
}

export default Admin;